// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__yRrBb","row":"styles_row__fynJ4","text":"styles_text__D9RjX","date":"styles_date__hgXK8"};